<script>
	import { fly } from "svelte/transition";
	import { familySize, income } from "../store";

	$: label =
		$familySize === "single" ? "Bruttotulo" : "Yhteenlaskettu bruttotulo";
</script>

<div>
	{#key $familySize}
		<label class="psl-label" for="income" in:fly={{ y: -15 }}>{label}:</label>
	{/key}
	<div class="input-wrapper">
		<input
			class="psl-input"
			type="number"
			min={0}
			step="50"
			id="income"
			bind:value={$income}
		/>
	</div>
</div>

<style>
	div {
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	input {
		padding-right: 4rem;
	}

	.input-wrapper {
		position: relative;
	}

	.input-wrapper:after {
		content: "€";
		font-size: 1.25rem;
		font-weight: 500;
		position: absolute;
		right: 2px;
		top: 2px;
		z-index: 1;
		height: calc(100% - 4px);
		width: 3rem;
		border-radius: 0 var(--border-radius-small) var(--border-radius-small) 0;
		border-left: 2px solid var(--color-blue);
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: var(--color-gray);
	}
</style>
